export enum CalendarPrintType {
	CALENDAR = 'calendar',
	SHIFT_REPORT = 'shift-report',
}
